import _ from "lodash";
import Services from "../../Services";

export default class Pagination {
    #$pagination;
    #$links;
    #$meta_links;

    constructor(pagination) {
        this.#$pagination = pagination;
        this.#$links = _.get(this.#$pagination, 'links');
        this.#$meta_links = _.get(this.#$pagination, 'meta.links', undefined);
    }

    static #getPageNumberWithUrl(url) {
        return Services.parseQueryString(Services.getQueryString(url))
    }

    static #isActive(item) {
        let isActive;
        if (_.isBoolean(isActive = _.get(item, 'active')) && isActive === true) {
            return ' active-page';
        }
        return '';
    }

    render() {
        if (_.has(this.#$pagination, 'meta.has_pages') && !_.get(this.#$pagination, 'meta.has_pages')) {
            return ''
        }

        const last_section = `${this.#next()}${this.#last()}`;

        return `<div class="row">
                    <div class="col-12">
                        <div class="pagination-cm">
                            ${this.#first()}
                            ${this.#prev()}
                            ${this.#pageItems()}
                            ${last_section}
                        </div>
                    </div>
                </div>`
    }

    #pageItems() {
        if (!_.isArray(this.#$meta_links)) {
            throw new Error('not exists pagination links');
        }
        let items = ''
        this.#$meta_links.forEach(item => {
            const url = _.isNull(item?.url) ? 'javascript:;' : item?.url
            let page = !isNaN(page = _.toNumber(_.get(item, 'label'))) ? page : '#'
            items = items.concat(`<a class="pagination-item${Pagination.#isActive(item)}${_.isNumber(page) ? '' : ' disabled'}" data-page="${page}" href="${url}">${item?.label || '...'}</a>`)
        })
        return items;
    }

    #prev() {
        if (!_.isArray(this.#$meta_links)) {
            throw new Error('not exists pagination links');
        }
        const prev = _.head(this.#$meta_links)
        this.#$meta_links = _.pull(this.#$meta_links, prev);
        if (!_.isUndefined(prev) && !_.isNull(prev?.url)) {
            const page = _.get(Pagination.#getPageNumberWithUrl(prev?.url), 'page')
            return `<a data-toggle="tooltip" data-theme="dark" data-page="${page}" data-placement="bottom" title="${_.get(prev, 'label', 'قبلی')}" href="${_.get(prev, 'url', 'javascript:;')}" class="pagination-item first">
                        <i class="fas fa-angle-right"></i>
                    </a>`
        }
        return `<a data-toggle="tooltip" data-theme="dark" data-placement="bottom" title="${_.get(prev, 'label', 'قبلی')}" href="javascript:;" class="pagination-item disabled first">
                    <i class="fas fa-angle-right"></i>
                </a>`
    }

    #next() {
        if (!_.isArray(this.#$meta_links)) {
            throw new Error('not exists pagination links');
        }
        const next = _.last(this.#$meta_links)
        this.#$meta_links = _.pull(this.#$meta_links, next);
        if (!_.isUndefined(next) && !_.isNull(next?.url)) {
            const page = _.get(Pagination.#getPageNumberWithUrl(next?.url), 'page')
            return `<a data-toggle="tooltip" data-theme="dark" data-page="${page}" data-placement="bottom" title="${_.get(next, 'label', 'بعدی')}" href="${_.get(next, 'url', 'javascript:;')}" class="pagination-item next">
                        <i class="fas fa-angle-left"></i>
                    </a>`
        }
        return `<a data-toggle="tooltip" data-theme="dark" data-placement="bottom" title="${_.get(next, 'label', 'بعدی')}" href="javascript:;" class="pagination-item disabled next">
                    <i class="fas fa-angle-left"></i>
                </a>`
    }

    #first() {
        let first = _.get(this.#$links, 'first'), isFirstCurrentPage
        const current_page = _.toNumber(_.get(this.#$pagination, 'meta.current_page'));
        if ((isFirstCurrentPage = _.isNumber(current_page) && current_page === 1)) {
            first = 'javascript:;'
        }
        if (_.isUndefined(first) || _.isNull(first)) {
            return `<a data-toggle="tooltip" data-theme="dark"
                        data-placement="bottom" title="اولین" href="javascript:;" class="pagination-item first disabled">
                        <i class="fas fa-angles-right"></i>
                    </a>`
        }
        return `<a data-toggle="tooltip" data-theme="dark"
                        data-placement="bottom" title="اولین" data-page="${1}" href="${first}" class="pagination-item first ${isFirstCurrentPage && 'disabled'}">
                        <i class="fas fa-angles-right"></i>
                    </a>`
    }

    #last() {
        let last = _.get(this.#$links, 'last'), isLastPageCurrent
        const current_page = _.toNumber(_.get(this.#$pagination, 'meta.current_page'));
        const last_page = _.toNumber(_.get(this.#$pagination, 'meta.last_page'));
        if ((isLastPageCurrent = (_.isNumber(current_page) && current_page === last_page))) {
            last = 'javascript:;'
        }
        if (_.isUndefined(last) || _.isNull(last)) {
            return `<a data-toggle="tooltip" data-theme="dark"
                        data-placement="bottom" title="آخرین" href="javascript:;" class="pagination-item last disabled">
                        <i class="fas fa-angles-left"></i>
                    </a>`
        }
        return `<a data-toggle="tooltip" data-theme="dark"
                        data-placement="bottom" title="آخرین" data-page="${last_page}" href="${last}" class="pagination-item last ${isLastPageCurrent && 'disabled'}">
                        <i class="fas fa-angles-left"></i>
                    </a>`
    }
}